module.exports = __webpack_public_path__ + "892db349f22b4c87c859a9ff2ef78ea1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ss/ss25.jpg
// module id = 731
// module chunks = 0